import { gql } from '@apollo/client';

export const SYNC_MASTER_LIST_METRICS = gql`
  mutation SyncMasterListMetrics($input: SyncMasterListMetricsRequest!) {
    syncMasterListMetrics(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        updated
        skipped_invalid_scope
      }
    }
  }
`;

export const UPDATE_METRIC = gql`
  mutation UpdateMetric($input: UpdateMetricRequest!) {
    updateMetric(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        deleted
        name
        description
        unit
        scope
        standard
        accumulation_method
        esg_category
        glo_id
      }
    }
  }
`;

export const CREATE_METRICS = gql`
  mutation CreateMetrics($input: CreateMetricsRequest!) {
    createMetrics(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result
    }
  }
`;
